import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { HttpHeaders } from '@angular/common/http';
import { constants } from 'src/app/constants';
import { EmployeeService } from 'src/app/api/admin/company/employee.service';
import { JobService } from 'src/app/api/admin/company/job.service';
import { BranchofficeService } from 'src/app/api/admin/branchoffice.service';
import SwalAlert from 'src/app/utils/swalalert';
declare var $: any;

@Component({
  selector: 'app-employees-form',
  templateUrl: './employees-form.component.html',
  styleUrls: ['./employees-form.component.css']
})
export class EmployeesFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables =======
  typesdocument: any = [];
  jobs: any = [];
  vehicletypes: any = [];
  statusmarital: any = [];
  sexs: any = [];
  branchoffices: any = [];
  // set values variables
  typeClientNatural: any = constants.CLIENT.TYPE[0];
  documentDni: any = constants.CLIENT.TYPE_DOCUMENT.DNI;
  documentRuc: any = constants.CLIENT.TYPE_DOCUMENT.RUC;
  typeDocumentSelected: any = null;

  imageUrl: any = null;
  fileUrlImage: any = null;

  service_alert: any = {
    class: 'success',
    message: '',
    show: false
  };

  // variables
  branchoffices_selecteds: any = [];
  assignedbranchs: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private generalService: GeneralService,
    private globalService: GlobalService,
    private jobService: JobService,
    private employeeService: EmployeeService,
    private branchOfficeService: BranchofficeService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      companyjob_id: [null, [Validators.required]],
      typedocument_id: [this.documentDni.id, [Validators.required]],
      code: [null],
      fullname: [null, [Validators.required, Validators.minLength(2)]],
      document: [null, [Validators.required]],
      cellphone: [null],
      telephone: [null],
      email: [null, [Validators.email]],
      address: [null],
      date_birthday: [null],
      status: [null],
      sex: [null],
      url_image: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    if (this.isEdit) {
      this.editData();
    }
    this.getTypeDocument();
    this.getJobs();
    this.getVehicleType();
    this.getStatusMarital();
    this.getSexs();
    this.getBranchOffices();
    setTimeout(() => {
      (<any>$('#typedocument_id')).attr('disabled', true);
      this.navigationTrackerService.initializeMenuAdmin('#tab-employees');
    }, 150);
  }

  editData() {
    this.employeeService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          companyjob_id: item_.companyjob_id,
          typedocument_id: item_.typedocument_id,
          vehicletype_id: item_.vehicletype_id,
          document: item_.document,
          fullname: item_.fullname,
          cellphone: item_.cellphone,
          email: item_.email,
          address: item_.email,
          date_birthday: item_.date_birthday,
          // status:item_.status.split(' ').join(''),
          status: item_.status,
          sex: item_.sex,
          url_image: item_.url_image
        });

        if (item_.status != null) {
          this.item.patchValue({
            status: item_.status.split(' ').join('')
          });
        }

        this.assignedbranchs = item_.assignedbranchs;
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getBranchOffices() {
    this.branchOfficeService.all().subscribe({
      next: (data: any) => {
        this.branchoffices = data.results;
        setTimeout(() => {
          for (let index in this.assignedbranchs) {
            (<any>$('#branch_' + this.assignedbranchs[index].id)).attr(
              'checked',
              'checked'
            );
            this.branchoffices_selecteds.push(this.assignedbranchs[index]);
          }
        }, 50);
      }
    });
  }

  getJobs() {
    this.jobService.all().subscribe({
      next: (data: any) => {
        this.jobs = data.results;
      }
    });
  }

  getVehicleType() {
    this.generalService.listVehicleType().subscribe({
      next: (data: any) => {
        this.vehicletypes = data.results;
      }
    });
  }

  getStatusMarital() {
    this.generalService.listStatusMarital().subscribe({
      next: (data: any) => {
        this.statusmarital = data;
      }
    });
  }

  getSexs() {
    this.generalService.listSexs().subscribe({
      next: (data: any) => {
        this.sexs = data;
      }
    });
  }

  getTypeDocument() {
    this.generalService.listTypeDocument().subscribe({
      next: (data: any) => {
        this.typesdocument = data;
        this.changeTypeDocument();
      }
    });
  }

  changeTypeDocument() {
    this.typeDocumentSelected = this.toolsService.searchArrById(
      this.item.value.typedocument_id,
      this.typesdocument
    );
  }

  selectedBranchoffice(branchoffice: any) {
    if(this.toolsService.notExistObjInArr(
      branchoffice,
      this.branchoffices_selecteds
    )){
      this.branchoffices_selecteds.push(branchoffice);
    }else{
      for(let i in this.branchoffices_selecteds){
        if(branchoffice.id == this.branchoffices_selecteds[i].id){
          this.branchoffices_selecteds.splice(i, 1); 
        }
      }      
    }
    
  }

  extractDni() {
    let param_ = this.item.value.document;
    if (!_.isEmpty(param_)) {
      this.generalService.extractDni(param_).subscribe({
        next: (data: any) => {
          if (data.success) {
            this.replaceExtractDataDni(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataDni(data: any) {
    this.item.patchValue({
      fullname: data.fullname,
      address: data.address
    });
  }

  extractRuc() {
    let param_ = this.item.value.document;
    if (param_ != null) {
      this.generalService.extractRuc(param_).subscribe({
        next: (data: any) => {
          if (data.success) {
            this.replaceExtractDataRuc(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataRuc(data: any) {
    this.item.patchValue({
      fullname: data.name,
      address: data.address
    });

    this.service_alert.class = data.alert_status;
    this.service_alert.message =
      'El cliente se encuentra con estado ' +
      data.status +
      ' y en condición ' +
      data.condition;
    this.service_alert.show = true;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      formData.append('item', JSON.stringify(data));
      formData.append('url_image', this.fileUrlImage);
      formData.append(
        'assignedbranchs',
        JSON.stringify(this.branchoffices_selecteds)
      );
      
      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.employeeService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.employeeService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (this.branchoffices_selecteds == 0) {
      this.alert.msgWarning(
        'Debe seleccionar al menos una Oficina/Local para el empleado'
      );
      return false;
    }
    return true;
  }

  cancel() {
    this.router.navigate(['admin/empresa/empleados/lista']);
  }
}
